import React, { useRef, useState } from 'react';
import { Volume2, VolumeX, Play } from 'lucide-react';
import { trackClick } from '../utils/analytics';

export const VideoPlayer = ({ src, title, className = '', aspectClass = 'aspect-video', showTitle = true }) => {
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);

  const toggleMute = (e) => {
    e.stopPropagation();
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setIsMuted(!isMuted);
    }
  };

  const togglePlay = () => {
    if (videoRef.current) {
      if (videoRef.current.paused) {
        videoRef.current.play();
        setIsPlaying(true);
        trackClick(`Video Play: ${title || src.split('/').pop()}`, window.location.pathname);
      } else {
        videoRef.current.pause();
        setIsPlaying(false);
      }
    }
  };

  const handleEnded = () => {
    setIsPlaying(false);
  };

  return (
    <div className={`relative group overflow-hidden rounded-xl shadow-lg ${className}`} data-testid="video-player">
      <div className={`relative ${aspectClass} bg-zinc-900 cursor-pointer`} onClick={togglePlay}>
        <video
          ref={videoRef}
          src={src + '#t=0.5'}
          className="w-full h-full object-cover"
          muted
          playsInline
          preload="metadata"
          onEnded={handleEnded}
          data-testid="video-element"
        />

        {/* Play/Pause overlay */}
        {!isPlaying && (
          <div className="absolute inset-0 flex items-center justify-center bg-black/30 transition-opacity">
            <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center shadow-xl hover:bg-red-700 transition-colors">
              <Play className="text-white ml-1" size={28} fill="white" />
            </div>
          </div>
        )}

        {/* Mute/Unmute button */}
        <button
          onClick={toggleMute}
          className="absolute bottom-3 right-3 z-10 bg-black/60 hover:bg-black/80 text-white p-2 rounded-full transition-colors"
          data-testid="mute-toggle"
          aria-label={isMuted ? 'Unmute' : 'Mute'}
        >
          {isMuted ? <VolumeX size={18} /> : <Volume2 size={18} />}
        </button>

        {/* Title overlay */}
        {showTitle && title && (
          <div className="absolute bottom-0 left-0 right-12 bg-gradient-to-t from-black/70 to-transparent p-4 pointer-events-none">
            <h4 className="text-white font-bold text-sm md:text-base">{title}</h4>
          </div>
        )}
      </div>
    </div>
  );
};
